import React from 'react';
import ContainerComp from './container';
import { globalContextInitialValue } from './value';
import { ThemeEnum } from 'types';

// init the main context (equal to store in redux)
export const GlobalContext = React.createContext(globalContextInitialValue(ThemeEnum.light));
export { ContainerComp as ContextProviderComp };
